import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import moment from "moment";
import withFetchHook from "../withFetchHook";

class SobrietyFormModal extends Component {
  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value);
  }

  updateResidentSobrieties(sobriety) {
    const { organizationName, resident } = this.props;

    return this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: {
          sobrieties_attributes: [sobriety]
        }
      })
    });
  }

  deleteSobriety() {
    const { sobriety, deleteSobriety, closeModal } = this.props;

    this.updateResidentSobrieties({
      id: sobriety.id,
      _destroy: true
    }).then(() => {
      deleteSobriety(sobriety);
      closeModal();
    });
  }

  saveSobriety() {
    const { sobriety, updateSobrieties, closeModal } = this.props;

    this.updateResidentSobrieties(sobriety).then((data) => {
      updateSobrieties(data.sobrieties);
      closeModal();
    });
  }

  render() {
    const {
      sobriety_date,
      relapse_date
    } = this.props.sobriety;

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Sobriety</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={6}>
              <Form.Group controlId="sobrietyDate" style={{ position: "fixed" }}>
                <Form.Label>Sobriety Date</Form.Label>
                <div></div>
                <DatePicker
                  className="form-control"
                  selected={sobriety_date ? moment(sobriety_date) : null}
                  onChange={(date) => {
                    this.handleChange(
                      "sobriety_date",
                      date ? date.format("YYYY-MM-DD") : null
                    )
                  }} />
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group controlId="relapseDate" style={{ position: "fixed" }}>
                <Form.Label>Relapse Date</Form.Label>
                <DatePicker
                  className="form-control"
                  selected={relapse_date ? moment(relapse_date) : null}
                  onChange={(date) => {
                    this.handleChange(
                      "relapse_date",
                      date ? date.format("YYYY-MM-DD") : null
                    )
                  }} />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="mt-5">
          {
            this.props.action === "edit" &&
            <Button
              variant="outline-danger"
              onClick={() => {
                const { sobriety } = this.props;
                this.deleteSobriety(sobriety);
              }}>
              Delete
            </Button>
          }
          <Button
            variant="info"
            onClick={() => this.saveSobriety()}>
            {this.props.action === "edit" ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.sobrietyModal.show,
    sobriety: state.ui.sobrietyModal.sobriety,
    action: state.ui.sobrietyModal.action,
    organizationName: state.organization.name,
    resident: state.resident
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "sobriety" }
      });
    },
    updateField: (name, value) => {
      dispatch({
        type: "UPDATE_RESOURCE_FIELD",
        payload: { resourceName: "sobriety", name, value }
      });
    },
    updateSobrieties: (sobrieties) => {
      dispatch({
        type: "UPDATE_SOBRIETIES",
        payload: { sobrieties }
      });
    },
    createSobriety: (sobriety) => {
      dispatch({
        type: "CREATE_SOBRIETY",
        payload: { sobriety }
      });
    },
    deleteSobriety: (sobriety) => {
      dispatch({
        type: "DELETE_SOBRIETY",
        payload: { sobriety }
      })
    }
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(SobrietyFormModal));
